import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';

class Filter extends Component {
    render() {
        const { ...rest } = this.props;
        const filters = [, {
            name: '中心编号',
            key: 'investigationSiteCode',
            type: 'input',
        }, {
            name: '中心名称',
            key: 'investigationSiteName',
            type: 'input',
            typeProperty: {
                style: { width: 120 }
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/site/researchCenterCost/Filter.js